"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var transformedSize = function transformedSize(size) {
  switch (size) {
    case '1x':
      return 24;

    case '2x':
      return 40;

    case '3x':
      return 64;

    default:
      return 40;
  }
};

var _default = function _default(theme) {
  return {
    root: {},
    noShadow: {
      boxShadow: 'none'
    },
    label: {},
    withoutRoundCorner: {
      borderRadius: 0
    },
    whiteBackground: {
      backgroundColor: theme.palette.common.white
    },
    textTransform: {
      '&.capitalize': {
        textTransform: 'capitalize'
      },
      '&.uppercase': {
        textTransform: 'uppercase'
      },
      '&.lowercase': {
        textTransform: 'lowercase'
      }
    },
    fabIcon: function fabIcon(props) {
      var size = transformedSize(props.size);
      return {
        width: size,
        height: size,
        minHeight: 'inherit',
        fontSize: size,
        '& svg': {
          fontSize: '0.514em'
        }
      };
    },
    fabOutlined: {
      backgroundColor: '#fff',
      '&.outline': {
        color: theme.palette.primary.main,
        border: "1px solid ".concat(theme.palette.secondary.buttonBorder)
      }
    }
  };
};

exports.default = _default;